<template>
    <div id="CrmList">
        <div :class="`loader${loaderClass}`" v-show="loading"></div>
        <template v-if="moduleVal != undefined">
        <template v-if="moduleVal == 'maintenance schedule'">
        <div class="admin-page-content customer-detail">
            <div class="row asset-top-section">
                <div class="page-name">
                    Previous Activity
                </div>
            </div>
            <section class="internal-container border-top-table-fl">
                <!-- <div class="btn-groups" style="margin-top:50px !important;"> -->
                    <!-- <button type="submit" class="btn btn-primary" v-on:click="addCrm"><i class="fp-add-icon"> </i>Add</button> -->
                <!-- </div> -->
                <div class="view-page-table bg-white data-table p-0">
                <vue-good-table
                    ref="listCrmTable"
                    mode="remote"
                    title="Crm"
                    @on-page-change="onPageChange"
                    @on-selected-rows-change="selectionChanged"
                    @on-column-filter="onColumnFilter"
                    @on-per-page-change="onPerPageChange"
                    @on-sort-change="onSortChange"
                    :totalRows="totalRecords"
                    :columns="columns"
                    :rows="rows"
                    :pagination-options="{
                        enabled: true,
                        position: 'bottom',
                        perPage: perPage,
                        setCurrentPage:listCurrentPage,
                        perPageDropdown:dropDownPerPage,
                        dropdownAllowAll: false,
                    }"
                    :select-options="{
                    enabled: term_value,
                    selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                    selectionInfoClass: 'custom-class',
                    selectionText: 'rows selected',
                    clearSelectionText: 'clear',
                    }"
                    :search-options="{
                    enabled: false,
                    }">

                    <template slot="table-row" slot-scope="props" v-for="(row,key) in rows">
                        <div :key="key">
                            <div v-if="props.column.field == 'action'">
                                <template v-if="canUpdateCrm">
                                    <router-link title="Edit Crm" class="fp-edit" v-bind:to="{name: 'CrmEdit',params:{id:props.row.id}}"></router-link>
                                </template>
                            </div>
                            <div v-else>
                                {{props.formattedRow[props.column.field]}}
                            </div>
                        </div>
                    </template>
                    <div slot="selected-row-actions">
                        <button v-if="term_value" id="deleteCrmBtn" v-on:click.prevent="crmDelete" class="btn btn-primary">Delete</button>
                    </div>
                </vue-good-table>
                </div>
            </section>
        </div>
        </template>
        <template v-else>
            <div v-if="moduleId != undefined">
                <div class="view-page-table">
                    <vue-good-table
                        ref="listCrmTable"
                        mode="remote"
                        title="Crm"
                        @on-page-change="onPageChange"
                        @on-column-filter="onColumnFilter"
                        @on-per-page-change="onPerPageChange"
                        @on-sort-change="onSortChange"
                        :totalRows="totalRecords"
                        :columns="columns"
                        :rows="rows"
                        :pagination-options="{
                            enabled: true,
                            position: 'bottom',
                            perPage: perPage,
                            perPageDropdown:dropDownPerPage,
                            dropdownAllowAll: false,
                        }">
                        <template slot="table-row" slot-scope="props" v-for="(row,key) in rows">
                            <div :key="key">
                                <div v-if="props.column.field == 'action'" class='btn-center-vvg'>
                                    <a href="javascript:void(0);" title="Edit Crm" v-if="canUpdateCrm && props.row.editable == 1" class="fp-edit" v-on:click.prevent="editCrmView(props.row.id)"></a>
                                </div>
                                <div v-else-if="props.column.field == 'notes'">
                                    <span v-fp-html="props.formattedRow[props.column.field]"></span>
                                </div>
                                <div v-else>
                                    {{props.formattedRow[props.column.field]}}
                                </div>
                            </div>
                        </template>
                    </vue-good-table>
                </div>
            </div>
        </template>
        </template>
        <div id="page-content-wrapper" class="admin-content-area" v-else>
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <div class="page-title"> CRM List</div>
                    <!-- Button for Clear Cache -->
                    <clear-cache-data :pageKey="[pageKey]" ></clear-cache-data>
                    <div class="btn-groups text-right">
                        <a href="javascript:void(0)" class="btn btn-secondary" v-on:click="exportCheck()">
                            <i class="fp-export"></i> Export
                        </a>
                        <router-link v-if="canAddCrm" class="btn btn-primary" v-bind:to="{name: 'CrmCreate'}" > <i class="fp-add"> </i> Add</router-link>
                    </div>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content crm-list">
                        <!-- <div class="FiltersLabel">Filters</div> -->
                        <data-table-filter-config :moduleName="'crmList'" ref="filterCrmList" @cancelSelection="cancelAll" :allowSameFilter="'allow'"></data-table-filter-config>
                        <div class="data-table bg-white overflow-hidden">
                          <p v-if="batchProcess" class="alert-success p-2" id="processFetchBatchMsg">Export file is in process. batch no. is {{batchNum}}. <router-link class="color-blue" v-bind:to="{name: 'BatchList'}" target="_blank" @click.native="batchProcess = 0"> Click Here</router-link> to check file status!</p>
                          <section class="data-table bg-white">
                                  <custom-pagination
                                      :page-changed="onPageChange"
                                      :per-page-changed="onPerPageChange" :moduleName="'crmList'" :position="'top'">
                                  </custom-pagination>
                                  <vue-good-table
                                      ref="listCrmTable"
                                      mode="remote"
                                      title="Crm"
                                      @on-page-change="onPageChange"
                                      @on-selected-rows-change="selectionChanged"
                                      @on-column-filter="onColumnFilter"
                                      @on-per-page-change="onPerPageChange"
                                      @on-sort-change="onSortChange"
                                      @on-select-all="onSelectAll"
                                      :totalRows="totalRecords"
                                      :columns="userColumns"
                                      :rows="rows"
                                      :pagination-options="{
                                          enabled: false,
                                          position: 'both',
                                          perPage: perPage,
                                          perPageDropdown:dropDownPerPage,
                                          setCurrentPage:listCurrentPage,
                                          dropdownAllowAll: false,
                                      }"
                                      :select-options="{
                                      enabled: term_value,
                                      selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                                      selectionInfoClass: 'custom-class',
                                      selectionText: 'rows selected',
                                      clearSelectionText: 'clear',
                                      }"
                                      :search-options="{
                                      enabled: false,
                                      }">

                                      <template slot="table-row" slot-scope="props" v-for="(row,key) in rows">
                                          <div :key="key">
                                              <div v-if="props.column.field == 'action'">
                                                  <router-link title="Edit Crm" v-if="canUpdateCrm && props.row.editable == 1" class="fp-edit" v-bind:to="{name: 'CrmEdit',params:{id:props.row.id}}"></router-link>
                                              </div>
                                              <div v-else-if="props.column.field == 'notes'">
                                                  <span v-fp-html="props.formattedRow[props.column.field]"></span>
                                              </div>
                                              <div v-else>
                                                  {{props.formattedRow[props.column.field]}}
                                              </div>
                                          </div>
                                      </template>
                                      <div slot="selected-row-actions">
                                          <button v-if="term_value" id="deleteCrmBtn" v-on:click.prevent="crmDelete" class="btn btn-primary">Delete</button>
                                      </div>
                                  </vue-good-table>
                                  <custom-pagination
                                      :page-changed="onPageChange"
                                      :per-page-changed="onPerPageChange">
                                  </custom-pagination>
                          </section>
                        </div>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="col-md-12">
                    <div class="error-template">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>
    </div>
</template>
<script>

import Vue from "vue";
import EventBus from "./event-bus";
import {commonMixins} from '../mixins/commonMixins';
import {dataTableMixins} from '../mixins/dataTableMixins';

    export default {
        name: "CrmList",
        mixins:[commonMixins,dataTableMixins],
        props: {
            moduleVal: {
                type: String,
                required: false,
                default:undefined
            },
            assetIdVal: {
                type: Object,
                required: false,
                default:undefined
            },
            customerId:{
                type: String,
                required: false,
                default:undefined
            },
            moduleId: {
                type: String,
                required: false,
                default:undefined
            },
        },
        data: () => ({
            firstLoad: 0,
            permissions: [],
            cantAccessPage: "",
            userColumns:[],
            columns: [
                {
                    label: 'Actions',
                    field: 'action',
                    sortable: false,
                },
                {
                    label: 'Module',
                    field: 'module',
                    filterable: true,
                    fpFieldType:"text",
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Module", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Note Category',
                    field: 'note_category',
                    fpFieldType:"option",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Note Category", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Subject',
                    field: 'subject',
                    fpFieldType:"text",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Subject", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Notes',
                    field: 'notes',
                    fpFieldType:"text",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Notes", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Activity Type',
                    field: 'activity_type',
                    filterable: true,
                    fpFieldType:"option",
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Activity Type", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: '#Unit',
                    field: 'unit_no',
                    fpFieldType:"text",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Unit", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Customer',
                    field: 'customer',
                    fpFieldType:"text",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Customer", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Vendor',
                    field: 'vendor',
                    fpFieldType:"text",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Vendor", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'User Created',
                    field: 'user_created',
                    fpFieldType:"text",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "User Created", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Assigned User',
                    field: 'user',
                    fpFieldType:"text",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "User", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Location',
                    field: 'location',
                    filterable: true,
                    fpFieldType:"option",
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Location", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },

                // {
                //     label: 'Name',
                //     field: 'name',
                //     fpFieldType:"text",
                //     filterable: true,
                //     hidden:false,
                //     filterOptions: {
                //         enabled: false, // enable filter for this column
                //         placeholder: "Name", // placeholder for filter input
                //         filterValue: '', // initial populated value for this filter
                //         trigger: "enter" //only trigger on enter not on keyup
                //     }
                // },
                {
                    label: 'Activity Time',
                    field: 'activity_time',
                    filterable: true,
                    fpFieldType:"date",
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "MM/DD/YYYY", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Follow Up Date Time',
                    field: 'follow_up_date',
                    filterable: true,
                    fpFieldType:"date",
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Follow Up Date", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Completed Date',
                    field: 'completed_date',
                    filterable: true,
                    fpFieldType:"date",
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Completed Date", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Completed Code',
                    field: 'completed',
                    fpFieldType:"text",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Completed Code", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Completed By',
                    field: 'completion_by',
                    fpFieldType:"text",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Completed By", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Priority Code',
                    field: 'priority',
                    fpFieldType:"text",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Priority Code", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
            ],
            rows: [],
            totalRecords: 0,
            term_value: false,
            loading:false,
            canUpdateCrm:false,
            canAddCrm:false,
            action:'list',
            pageKey:"_crm_list_",
            batchProcess:0,
            batchNum:"",
        }),
        metaInfo () {
            if (this.moduleVal == undefined) {
                return {
                    title: "CRM List | " +process.env.COPYRIGHT_NAME
                }
            }
        },
        watch:{

            //check permission change
            permissions: function (permissions) {

                var self = this;
                if (permissions.length > 0) {
                    for (var i = 0; i < permissions.length; i++) {
                        if (permissions[i].name == 'list_crm') {
                            self.cantAccessPage = true;
                        }
                        if (permissions[i].name == 'delete_crm') {
                            self.term_value = true;
                        }
                        if (permissions[i].name == 'add_crm') {
                            self.canAddCrm = true;
                            self.canUpdateCrm = true;
                        }
                    }
                }

            }

        },
        created: function() {

        },
        beforeDestroy(){
            this.$root.$off('activity_refresh');
        },
        mounted: function() {
            var self = this;

            //self.loadList();
            self.getPermissions();
            //load activity on the basis of module name and vehicle id
            if(self.moduleVal != undefined){
                // console.log(self.moduleVal);
                if (self.moduleVal == 'maintenance schedule') {
                    if(self.assetIdVal != undefined || self.assetIdVal != null){
                        console.log(self.assetIdVal.value);
                        // for( var i=0; i<this.columns.length; i++ ) {
                        //     if ( this.columns[i].field == 'action' ) {
                        //         this.$set(this.columns[i], 'hidden', true);
                        //     }
                        // }
                    }
                }else{
                    //hide module column and customer column from list when call from customer view page
                    for (let index = 0; index < this.columns.length; index++) {

                        if(this.columns[index].field == 'customer'){
                            this.$set(this.columns[index], 'hidden', true);
                        }
                        if(this.columns[index].field == 'module'){
                            this.$set(this.columns[index], 'hidden', true);
                        }
                        if(this.columns[index].field == 'vendor'){
                            this.$set(this.columns[index], 'hidden', true);
                        }
                    }
                }
            }
            this.$root.$on('activity_refresh', () => {
                self.loadList();
            });
        },
        methods: {
            cancelAll: function (cancelAll) {
              this.$refs.listCrmTable.unselectAllInternal();
            },
            /*updateParams(newProps) {
                this.serverParams = Object.assign({}, this.serverParams, newProps);
            },

            onPageChange(params) {
                this.updateParams({page: params.currentPage});
                this.loadList();
            },

            onPerPageChange(params) {
                this.serverParams.page=1;
                this.updateParams({perPage: params.currentPerPage});
                this.totalRecords = self.totalRecords;
                this.loadList();
            },

            onColumnFilter(params) {
                this.updateParams(params);
                {
                    field:('name');
                    field:('code');
                    field:('description');
                };
                var filtersPr = JSON.parse(JSON.stringify(this.serverParams));
                var filters = filtersPr.columnFilters;
                if (this.firstLoad == 1 || filters.name || filters.code || filters.description ) {
                    this.loadList();
                }
            },*/

            selectionChanged(param) {
                var self = this;
                // console.log(self.computed.selectedRows);
                // var rowData = self.$refs['my-table'].selectedRows;
                // console.log(rowData);
                self.serverParams.selectedAll = false;
                if(param.selectedRows.length == 100) {
                  EventBus.$emit('clear-selection', false);
                } else {
                  EventBus.$emit('clear-all-flags', false);
                }
                return;
            },
            exportCheck: function() {
                var self = this;
                var count = 0;
                var actionFlag = "";
                var data = this.$refs['listCrmTable'].selectedRows;
                count = data.length;

                if(this.serverParams.selectedAll == true){
                    actionFlag = "";
                }else if(count != 0 && count <= 100){
                    actionFlag = "export";
                }

                this.exportReports(actionFlag);
            },

            /*onSortChange(params) {
                this.updateParams({
                    sort: {
                        type: params[0].type,
                        field: params[0].field,
                    },
                });
                this.loadList();
            },*/

            loadList() {
                var data = this.$refs['listCrmTable'].selectedRows;
                var self = this;
                var use = [];
                for (var i = 0; i < data.length; i++) {
                    use.push(this.$refs['listCrmTable'].selectedRows[i].id)
                }
                self.loading = true;
                //load activity on the basis of module name and vehicle id
                if(self.moduleVal != undefined){
                    if (self.moduleVal == 'maintenance schedule') {
                        var fields = {
                            page: self.serverParams.page,
                            perPage: self.serverParams.perPage,
                            filters: self.serverParams.columnFilters,
                            sort: self.serverParams.sort,
                            flag: self.moduleVal,
                            vehicle_id: self.assetIdVal.value,
                            action:self.action,
                            all:self.serverParams.selectedAll,
                            id:use
                        };
                    }else{
                        //CRM for customer view page
                        var fields = {
                            page: self.serverParams.page,
                            perPage: self.serverParams.perPage,
                            filters: self.serverParams.columnFilters,
                            sort: self.serverParams.sort,
                            flag: self.moduleVal,
                            module_id: self.moduleId,
                            action:self.action,
                            all:self.serverParams.selectedAll,
                            id:use
                        };
                    }

                }else{
                    //from dashboard view all button
                    if (self.$route.query.from != undefined && self.$route.query.from != null) {
                        if (self.$route.query.from == "dashboard") {
                            self.serverParams.sort = {
                                field:"follow_up_date",
                                type:"asc"
                            }
                            var fields = {
                                page: self.serverParams.page,
                                perPage: self.serverParams.perPage,
                                filters: self.serverParams.columnFilters,
                                sort: self.serverParams.sort,
                                flag: "dashboard",
                                module_id: "",
                                action:self.action,
                                all:self.serverParams.selectedAll,
                                id:use
                            };
                        }
                    }else{
                        var fields = {
                            page: self.serverParams.page,
                            perPage: self.serverParams.perPage,
                            filters: self.serverParams.columnFilters,
                            sort: self.serverParams.sort,
                            action:self.action,
                            all:self.serverParams.selectedAll,
                            id:use
                        };
                    }
                }
                self.firstLoad = 1;
                $.ajax({
                    url: process.env.ROOT_API + "/crm/list",
                    type: "POST",
                    data: fields,
                    headers: this.ajxHeaders,
                    dataType: "json",
                    success: function (data) {
                        self.loading = false;
                        // console.log(data);
                        if (data.status == "success") {
                            if ( self.action == "export" ||  self.action == "export_queue") {
                                if ( data.code == "201" ) {
                                    alert(data.message);
                                } else {
                                    if ( self.action == "export" ) {
                                        self.excel = data.content;
                                        var save = document.createElement("a");
                                        save.href = self.excel;
                                        save.download = data.content;
                                        save.target = "_blank";

                                        document.body.appendChild(save);
                                        save.click();
                                        document.body.removeChild(save);

                                    } else {

                                        self.batchProcess = 1;
                                        self.batchNum = data.content;
                                    }
                                }
                                self.action = "list";
                                self.loadList();
                            }else if (self.action == 'delete'){
                                self.action = 'list';
                                if (self.moduleVal == undefined) {
                                    self.$refs.filterCrmList.clearSelectAll();
                                    EventBus.$emit('clear-all-flags', false);
                                }
                                self.loadList();

                            }else{

                                self.rows = data.content.row;
                                self.totalRecords = data.content.totalRecords;
                            }
                            self.filteredFlag = false;
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        self.generateStatusCodeMessage(jqXHR,false,'load-crm-list')
                    }
                });
            },

            crmDelete() {
                var self = this;
                self.$swal({
                    title: 'Are you sure that you want to delete this Crm?',
                    type: 'info',
                    showCancelButton: true,
                    confirmButtonText: 'Yes',
                    cancelButtonText: 'No',
                    showCloseButton: false,
                    showLoaderOnConfirm: true
                }).then((result) => {
                    if (result.value) {
                      self.action = 'delete';
                      self.loadList();

                    } else {
                      console.log("no");
                    }
                });
                
            },
            editCrmView(id){
                var self = this;
                self.$parent.editCrmFromView(id);
            }
        }
    };
</script>




// WEBPACK FOOTER //
// src/components/CrmList.vue